import React from 'react'
import { connect } from 'react-redux'
import Login from './Login'
import WelcomeBack from './WelcomeBack'

const mapStateToProps = (state, props) => {
  return {
    authToken: state.token,
    name: state.user ? state.user.name : null,
    avatarUrl: state.user ? state.user.avatarUrl : null,
  }
}

const Container = ({ authToken, name, avatarUrl, queryString }) => {
  if (authToken)
    return <WelcomeBack name={name} avatarUrl={avatarUrl} />
  return <Login queryString={queryString} />
}


export default connect(mapStateToProps)(Container)



// WEBPACK FOOTER //
// ./src/pages/Login/LoginContinue/Container.js